import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=845b4a1c&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&id=845b4a1c&prod&lang=less&scoped=true&"
import style1 from "./notice.vue?vue&type=style&index=1&id=845b4a1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845b4a1c",
  null
  
)

export default component.exports